import React, { Component } from "react";
import createGraph from "ngraph.graph";
import path from "ngraph.path";
import "./../App.css";
import "react-select/dist/react-select.css";
import $ from "jquery";
import { distance, transformWindowCoordinateToCanvasCoord } from "./../utils/calc";
import { formatDisplayName } from "./../utils/nameFormat";
import { drawRoute, clearRoutes } from "./../utils/canvasPainter";
import {
  drawStartIcon,
  removeStartIcon,
  drawEndIcon,
  removeEndIcon,
  drawStairsIcon,
  removeStairsIcon,
  drawServiceIcon,
  removeServiceIcon
} from "./../utils/cssAnimator";
import StoreWidget from "./StoreWidget";
import DisccountWidget from "./DisccountWidget";
import FloorsStrip from "./FloorsStrip";

import startIcon from "../../assets/img/ic_pin_blanco.png";
import endIcon from "../../assets/img/ic_ubicacion_blanco.png";
import routeIcon from "../../assets/img/ic_pin_magenta.png";
import routeIconWhite from "../../assets/img/ic_pin_blanco.png";
import tagIcon from "../../assets/img/ic_etiqueta_magenta.png";
import tagIconWhite from "../../assets/img/ic_etiqueta.png";
import whiteLine from "../../assets/img/img_linea_blanca.png";

import banoPin from "../../assets/img/ic_banos_pin.png";
import cajeroPin from "../../assets/img/ic_cajero_pin.png";
import directorioPin from "../../assets/img/ic_directorio_pin.png";
import informacionPin from "../../assets/img/ic_informacion_pin.png";
import lactanciaPin from "../../assets/img/ic_lactancia_pin.png";
import ascensorPin from "../../assets/img/ic_ascensor_pin.png";
import estacionamientoPin from "../../assets/img/services/ic_estacionamiento_pin.png";
import casinoPin from "../../assets/img/ic_casino_pin.png";
import cafeteriaPin from "../../assets/img/ic_cafeteria_pin.png";
import banoMarker from "../../assets/img/services/ic_bano_seleccionado.png";
import cajeroMarker from "../../assets/img/services/ic_cajero_seleccionado.png";
import casinoMarker from "../../assets/img/services/ic_casino_seleccionado.png";
import cafeteriaMarker from "../../assets/img/services/ic_cafeteria_seleccionado.png";

// Íconos de los servicios que quedan siempre visibles sobre el plano
// (config.servicesOnMap), por tipo de servicio.
const SERVICE_MARKER_ICONS = {
  bathroom: banoMarker,
  casino: casinoMarker,
  cafeteria: cafeteriaMarker,
  redbanc: cajeroMarker
};

// Edificios según el plano de sectores de FEN (mapacoloruchile.png), con la
// paleta propia del mapa:
// Torre 26, Edificio Placa (incluye Casino, Banco de Chile y Aula Magna),
// Biblioteca, Tecno Aulas y Corporativo Z. Las áreas ya vienen
// pintadas en la imagen de cada piso; aquí solo van los nombres.
// Posiciones en % de la imagen completa (1522x856, con la franja superior).
const BUILDINGS_META = {
  "p-1": {
    tecnoaulas: { name: "Tecnoaulas", color: "#8c7128", cx_pct: 64.62, cy_pct: 50.24 },
    edificioZ: { name: "Edificio Z", color: "#537f5b", cx_pct: 77.91, cy_pct: 69.41 }
  },
  "p1": {
    torre26: { name: "Torre 26", color: "#255881", cx_pct: 20.94, cy_pct: 41.43 },
    placa: { name: "Edificio Placa", color: "#9c4668", cx_pct: 37.18, cy_pct: 48.17 },
    bancoDeChile: { name: "Banco de Chile", color: "#9c4668", cx_pct: 34.49, cy_pct: 55.14 },
    casino: { name: "Casino", color: "#9c4668", cx_pct: 36.14, cy_pct: 33.53 },
    biblioteca: { name: "Biblioteca", color: "#5b4b8a", cx_pct: 50.59, cy_pct: 28.86 },
    aulaMagna: { name: "Aula Magna", color: "#9c4668", cx_pct: 49.28, cy_pct: 68.57 },
    tecnoaulas: { name: "Tecnoaulas", color: "#8c7128", cx_pct: 58.22, cy_pct: 49.29 },
    edificioZ: { name: "Edificio Z", color: "#537f5b", cx_pct: 77.91, cy_pct: 69.14 }
  },
  "p2": {
    biblioteca: { name: "Biblioteca", color: "#5b4b8a", cx_pct: 50.59, cy_pct: 28.86 },
    torre26: { name: "Torre 26", color: "#255881", cx_pct: 20.94, cy_pct: 41.43 },
    placa: { name: "Edificio Placa", color: "#9c4668", cx_pct: 39.33, cy_pct: 44.61 },
    tecnoaulas: { name: "Tecnoaulas", color: "#8c7128", cx_pct: 57.05, cy_pct: 47.62 },
    edificioZ: { name: "Edificio Z", color: "#537f5b", cx_pct: 77.98, cy_pct: 70.25 }
  },
  "p3": {
    biblioteca: { name: "Biblioteca", color: "#5b4b8a", cx_pct: 50.59, cy_pct: 28.86 },
    torre26: { name: "Torre 26", color: "#255881", cx_pct: 20.94, cy_pct: 41.43 },
    placa: { name: "Edificio Placa", color: "#9c4668", cx_pct: 39.21, cy_pct: 46.75 },
    tecnoaulas: { name: "Tecnoaulas", color: "#8c7128", cx_pct: 57.46, cy_pct: 48.35 },
    edificioZ: { name: "Edificio Z", color: "#537f5b", cx_pct: 77.68, cy_pct: 69.75 }
  }
};

const CANVAS_ID_BY_FLOOR = {
  "-1": "canvaspm1",
  "0": "canvasp0",
  "1": "canvasp1",
  "2": "canvasp2",
  "3": "canvasp3",
  "4": "canvasp4"
};

let PISO_m1_INDEX = -1;
let PISO_0_INDEX = 0;
let PISO_1_INDEX = 1;
let PISO_2_INDEX = 2;
let PISO_3_INDEX = 3;
let PISO_4_INDEX = 4;
let defaultServicesFloor = 1;
let defaultParkingFloor = 0;

let DEFAULT_ANIMATION_TIMEOUT_EXTEND = 5000;
let DEFAULT_ANIMATION_TIMEOUT = 3000;
let START_ANIMATION_WAIT = 2000;

let MODE_MAP = "mapa";
let MODE_DISCCOUNTS = "discs";

let pm1, p0, p1, p2, p3, p4;

class MapView extends Component {
  constructor(props) {
    super(props);
    let { config } = this.props;
    defaultServicesFloor = config.piso_1;
    defaultParkingFloor = config.defaultParkingFloor;
    this.state = {
      start: false,
      end: false,
      bw: config.w,
      bh: config.h,
      canvasses: [],
      currentCanvas: false,
      context: false,
      graphs: [],
      markedSteps: [],
      currentFloor: PISO_1_INDEX,
      marginTop: 250,
      onAnimation: false,
      mode: MODE_MAP,
      disccounts: []
    };
    pm1 = this.props.pm1;
    p0 = this.props.p0;
    p1 = this.props.p1;
    p2 = this.props.p2;
    p3 = this.props.p3;
    p4 = this.props.p4;
    this.lastWidth = $(window).width();
    this.state.screenWidth = this.lastWidth;
    this.handleResize = this.handleResize.bind(this);
  }

  isUpOrDown(text) {
    if(!text) return '';
    let { start, end } = this.props;
    if (!start || !end) return '';
    let startFloor = parseInt(start.store_info.nivel, 10);
    // Un servicio elegido por tipo no trae piso: se toma del nodo que se usa como destino.
    let endInfo = end.store_info || this.getEnd(startFloor).store_info;
    return text.replace('Escaleras', (parseInt(endInfo.nivel, 10) > startFloor ? 'Subir' : 'Bajar') + ' Escaleras');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    // Redimensionar canvas cuando cambie el tamaño de la ventana.
    // En mobile, el teclado virtual (al enfocar los combobox) y la barra de
    // direcciones (al hacer scroll) disparan "resize" cambiando solo el alto,
    // no el ancho. Si reaccionamos a esos eventos igual, se limpia el canvas
    // (borrando la ruta dibujada) sin necesidad, y una ruta a medio dibujar
    // termina de pintarse sobre un canvas ya redimensionado, dejando la
    // línea desalineada. Por eso solo actuamos si el ANCHO realmente cambió.
    let currentWidth = $(window).width();
    if (currentWidth === this.lastWidth) return;
    this.lastWidth = currentWidth;

    const { canvasses, bw, bh } = this.state;

    if (canvasses && Object.keys(canvasses).length > 0) {
      let aspectRatio = bh / bw;

      Object.values(canvasses).forEach(canvas => {
        if (canvas) {
          canvas.width = currentWidth;
          canvas.height = currentWidth * aspectRatio;
          canvas.style.width = currentWidth + 'px';
          canvas.style.height = (currentWidth * aspectRatio) + 'px';
        }
      });

      // Guardamos el ancho actual en el estado ANTES de redibujar: la ruta y
      // los iconos leen este valor (no $(window).width() en vivo) para que
      // todo lo que se dibuje en esta pasada use exactamente la misma escala.
      this.setState({ screenWidth: currentWidth }, () => {
        this.redrawCurrentRoute();
      });
    }
  }

  redrawCurrentRoute() {
    const { start, end } = this.props;
    if (start && end) {
      // Limpiar rutas existentes y redibujar
      clearRoutes(this.state.canvasses);
      setTimeout(() => {
        this.findRoute();
      }, 100);
    }
  }

  componentWillReceiveProps(props) {
    let { start, end, config } = props;
    // App vuelve a renderizar al cargar tiendas y descuentos; si la ruta no
    // cambió no hay que relanzarla: varias animaciones en paralelo comparten
    // el estado de canvasPainter, la ruta queda cortada y onAnimation nunca
    // vuelve a false (bloqueando "Repetir" y los íconos de servicios).
    if (props.routeKey === this.props.routeKey) return;
    if (start && end) {
      let startFloor = parseInt(start.store_info.nivel, 10);
      let canvasses = {};
      if (config.floors["-1"])
        canvasses = this.setupCanvas(
          "canvaspm1",
          PISO_m1_INDEX,
          props,
          canvasses
        );
      if (config.floors["0"]) {
        // console.log("Configuando piso 0", "Canvasp0", PISO_0_INDEX, props, canvasses)
        canvasses = this.setupCanvas(
          "canvasp0",
          PISO_0_INDEX,
          props,
          canvasses
        );
      }
      if (config.floors["1"]) {
        // console.log("Configuando piso 1", "canvasp1", PISO_1_INDEX, props, canvasses)
        canvasses = this.setupCanvas(
          "canvasp1",
          PISO_1_INDEX,
          props,
          canvasses
        );
      }
      if (config.floors["2"])
        console.log("Configuando piso 2");
        canvasses = this.setupCanvas(
          "canvasp2",
          PISO_2_INDEX,
          props,
          canvasses
        );
      if (config.floors["3"])
        canvasses = this.setupCanvas(
          "canvasp3",
          PISO_3_INDEX,
          props,
          canvasses
        );
      if (config.floors["4"])
        canvasses = this.setupCanvas(
          "canvasp4",
          PISO_4_INDEX,
          props,
          canvasses
        );
      let context = canvasses[startFloor].getContext("2d");
      this.showFloorCanvas(startFloor);
      this.setState(
        {
          currentCanvas: canvasses[startFloor],
          currentFloor: startFloor,
          canvasses,
          context,
          graphs: []
        },
        () => this.setupGraphs()
      );
    }
  }

  setupCanvas(id, index, props, canvass) {
    let { config, start } = props;
    let startFloor = parseInt(start.store_info.nivel, 10);
    if (!$(`#${id}`).length) {
      // NO existe
      // console.log("no existe el id canvas", id);
      this.generateCanvas(
        id,
        config.floors[index.toString()],
        startFloor !== index,
        index
      );
    }
    if (startFloor !== index) {
      // console.log("start floor no es igual al index", id)
      // Ocultar también los nombres/íconos del piso: si quedaron visibles de
      // la ruta anterior se superponen con los del piso de partida.
      $(`#${id}`).css("display", "none");
      $(`#${id}-labels`).css("display", "none");
    }
    canvass[index] = $(`#${id}`)[0];
    return canvass;
  }

  generateCanvas(id, background, hide = true, floor) {
    let { bw, bh } = this.state;
    let canvas = document.createElement("canvas");
    let canvasAux = $(canvas).clone()[0];
    let style = `background: url(${background}); background-size: contain; background-repeat: no-repeat;`;
    if (hide) style += ` display: none;`;
    canvasAux.style = style;
    canvasAux.id = id;
    let bdy = document.getElementById("mapcontent");
    bdy.appendChild(canvasAux);

    // Dimensionar el canvas según el ancho actual de la ventana (igual que los iconos)
    let currentWidth = $(window).width();
    let aspectRatio = bh / bw;
    canvasAux.width = currentWidth;
    canvasAux.height = currentWidth * aspectRatio;
    canvasAux.style.width = currentWidth + 'px';
    canvasAux.style.height = (currentWidth * aspectRatio) + 'px';

    this.generateBuildingLabels(id, floor, hide, currentWidth, aspectRatio);

    return canvasAux;
  }

  // Nombres de edificios (Torre 26, Tecnoaulas, Edificio Z) sobre el plano.
  // Solo texto: los colores ya están pintados directamente en la imagen del piso.
  generateBuildingLabels(canvasId, floor, hide, currentWidth, aspectRatio) {
    let meta = BUILDINGS_META[`p${floor}`] || {};

    let wrap = document.createElement("div");
    wrap.id = `${canvasId}-labels`;
    wrap.style = `position:absolute; top:250px; left:0; width:${currentWidth}px; height:${currentWidth * aspectRatio}px; pointer-events:none; z-index:20;${hide ? " display:none;" : ""}`;

    Object.keys(meta).forEach(key => {
      let b = meta[key];
      let label = document.createElement("div");
      label.textContent = b.name;
      label.style = `position:absolute; left:${b.cx_pct}%; top:${b.cy_pct}%; transform:translate(-50%,-50%); background:rgba(255,255,255,0.92); color:${b.color}; font-size:10px; font-weight:500; letter-spacing:0.2px; padding:2px 7px; border-radius:8px; border:1px solid ${b.color}; white-space:nowrap; pointer-events:none;`;
      wrap.appendChild(label);
    });
    this.appendServiceMarkers(wrap, floor);

    let bdy = document.getElementById("mapcontent");
    bdy.appendChild(wrap);
  }

  // Servicios (baños, casino, cafetería, Banco de Chile) siempre visibles sobre el plano,
  // aunque no sean el destino elegido. Al tocar uno se traza la ruta hacia ese
  // servicio en particular (no al más cercano de su tipo).
  appendServiceMarkers(wrap, floor) {
    let { config } = this.props;
    if (!config.servicesOnMap) return;
    let names = config.serviceNames || {};
    (this.getFloorNodes(floor) || [])
      .filter(n => n.service && n.service_info)
      .forEach(n => {
        let type = config.services.find(s => n.service_info[s]);
        if (!type || !SERVICE_MARKER_ICONS[type]) return;
        // Misma transformación que la ruta y los pines, en píxeles de la imagen.
        let pos = transformWindowCoordinateToCanvasCoord(n.x, n.y, config.w, config.h, floor, config.w);
        let name = names[type] || n.service_description;
        let marker = document.createElement("img");
        marker.src = SERVICE_MARKER_ICONS[type];
        marker.alt = name;
        marker.title = name;
        marker.className = "service-marker";
        marker.style.left = `${pos.x / config.w * 100}%`;
        marker.style.top = `${pos.y / config.h * 100}%`;
        marker.onclick = () => this.onServiceMarkerClick(n, type, name, floor);
        wrap.appendChild(marker);
      });
  }

  onServiceMarkerClick(node, type, name, floor) {
    if (this.state.onAnimation || !this.props.onServiceSelected) return;
    this.props.onServiceSelected({ service: true, type, name, node, floor });
  }

  // Paso 0º
  findRoute() {
    let { currentFloor, canvasses, onAnimation } = this.state;
    let { start, end } = this.props;
    removeEndIcon();
    removeServiceIcon();
    removeStartIcon();
    removeStairsIcon();
    removeStairsIcon();
    clearRoutes(canvasses);
    if (start && end) {
      this.setState({
        currentFloor: parseInt(start.store_info.nivel, 10)
      });
      let ctx = this;
      let startFloorIndex = parseInt(start.store_info.nivel, 10);
      let auxEnd = this.getEnd(startFloorIndex);
      if (currentFloor.toString() !== start.store_info.nivel) {
        this.findRouteTravelStartingFloor(startFloorIndex);
      } else {
        this.findRouteOnStartFloor(start, auxEnd, startFloorIndex, ctx);
      }
    }
  }

  // Paso 0.5: Buscar el servicio ojalá en el piso de partida si no el más cercano
  getEnd(startFloorIndex) {
    let { end, start } = this.props;
    if(!end.service) return end;
    // Servicio elegido tocando su ícono en el plano: ir a ese nodo exacto.
    if (end.node) return Object.assign({ store_info: { nivel: `${end.floor}` } }, end.node);
    let ret = {};
    let retFloor = startFloorIndex;
    let inCurrFloor = this.getFloorNodes(startFloorIndex).filter(
      n => {
        return  n.service && n.service_info[end.type]
       }
    );
    if (inCurrFloor.length === 1) {
      // Es el único del piso
      ret = inCurrFloor[0];
    } else if (inCurrFloor.length > 1) {
      ret = this.getClosest(start, inCurrFloor)[0];
    } else if (end.service && end.type === "parking") {
      ret = this.getFloorNodes(defaultParkingFloor).filter(
        n => n.service && n.service_info.parking === true
      )[0];
      retFloor = defaultParkingFloor;  
    } else {
      // No hay en el piso: primero el piso de servicios por defecto (1) y, si
      // tampoco hay (p.ej. la cafetería, solo en el Zócalo), el primer piso
      // que tenga ese servicio.
      let floors = [defaultServicesFloor, PISO_m1_INDEX, PISO_0_INDEX, PISO_1_INDEX, PISO_2_INDEX, PISO_3_INDEX, PISO_4_INDEX];
      for (let i = 0; i < floors.length; i++) {
        let candidates = (this.getFloorNodes(floors[i]) || []).filter(
          n => n.service && n.service_info[end.type]
        );
        if (candidates.length) {
          ret = this.getClosest(start, candidates)[0];
          retFloor = floors[i];
          break;
        }
      }
    }
    return Object.assign({ store_info: { nivel: `${retFloor}` } }, ret);
  }

  // 1º: Si es que la vista está en un piso distinto a del cliente
  // Se llama solo cuando se repite la animación
  findRouteTravelStartingFloor(startFloorIndex) {
    let { start } = this.props;
    let end = this.getEnd(parseInt(start.store_info.nivel, 10));
    let { currentFloor } = this.state;
    let ctx = this;
    this.hideFloorCanvas(currentFloor);
    this.showFloorCanvas(startFloorIndex);
    this.setCurrentCanvas(startFloorIndex, () => {
      setTimeout(function() {
        ctx.findRouteOnStartFloor(start, end, startFloorIndex, ctx);
      }, DEFAULT_ANIMATION_TIMEOUT);
    });
  }

  // 2º: Cuando la vista ya está en el piso de inicio
  findRouteOnStartFloor(start, end, startFloorIndex, ctx) {
    let { marginTop, currentCanvas, screenWidth } = ctx.state;
    let { config } = this.props;

    console.log("findRouteOnStartFloor", start, end, startFloorIndex, ctx.state);
    drawStartIcon(start.x, start.y, config.w, config.h, 200, !!start.store_info ? formatDisplayName(start.store_info.title) : undefined, startFloorIndex, screenWidth);
    setTimeout(() => {
      removeStartIcon();
      drawStartIcon(start.x, start.y, config.w, config.h, 200, undefined, startFloorIndex, screenWidth);

      let endFloorIndex = parseInt(end.store_info.nivel, 10);
      if (start.store_info.nivel !== end.store_info.nivel) {
        let accesses = ctx.getClosestAccess(start, startFloorIndex);
        let index = 0;
        let access = false;
        let accessRoute = false;
        while (!accessRoute && accesses[index]) {
          // Iteramos por todos los accesos del piso, los más cercanos primero
          access = accesses[index];
          accessRoute = ctx.getAccessOnSameStairColumn(
            accesses[index],
            end.store_info.nivel,
            [],
            ctx
          );
          index++;
        }
        if (accessRoute) {
          let endFloor = parseInt(end.store_info.nivel, 10);
          let id = accessRoute[accessRoute.length - 1].access_info.pairs[end.store_info.nivel];
          accessRoute.push(this.getNodeById(id, endFloor));
        }
        if (!accessRoute) {
          //No se encontró ruta en una misma columna de escaleras. Intentamos lo mismo pero exhaustivamente
          index = 0;
          access = false;
          // Se establece un signo para que forzar la búsqueda a no devolverse. Como una heurística
          let sign =
            parseInt(start.store_info.nivel, 10) < endFloorIndex ? "up" : "down";
          while (!accessRoute && accesses[index]) {
            access = accesses[index];
            ctx.getAccessExhaustively(
              accesses[index],
              end.store_info.nivel,
              [],
              ctx,
              res => {
                if (!accessRoute) accessRoute = [...res];
              },
              sign
            );
            index++;
          }
          let auxAccessRoute = [];
          console.log("EL acceso", accessRoute);
          if (accessRoute) {
            accessRoute.forEach((n, i, arr) => {
              // Agregamos los nodos de conexión que puedan faltar
              let next = arr[i + 1];
              auxAccessRoute.push(n);
              if (next) {
                if (next.access_info.floor !== n.access_info.floor) {
                  let id = n.access_info.pairs[next.access_info.floor];
                  let auxFloor = parseInt(next.access_info.floor, 10);
                  auxAccessRoute.push(this.getNodeById(id, auxFloor));
                }
              } else {
                let endFloor = parseInt(end.store_info.nivel, 10);
                let id = n.access_info.pairs[end.store_info.nivel];
                auxAccessRoute.push(this.getNodeById(id, endFloor));
              }
            });
            //auxAccessRoute.pop(); // Sacamos el último porque es redundante
            accessRoute = auxAccessRoute;
          } else {
            // No route found between floors
            this.setState({
              errorMessage: "No se pudo encontrar una ruta entre los pisos seleccionados."
            });
            return;
          }
        }
        drawStairsIcon(access.x, access.y, config.w, config.h, 200, undefined, startFloorIndex, screenWidth);
        let result = ctx
          .generatePathFinder(startFloorIndex)
          .find(access.id, start.id);
        drawRoute(result.map(r => r.data), currentCanvas, marginTop, null, config, startFloorIndex, screenWidth);
        setTimeout(() => {
          removeStairsIcon();
          drawStairsIcon(access.x, access.y, config.w, config.h, 200, !!access.access_description ? this.isUpOrDown(access.access_description) : undefined, startFloorIndex, screenWidth);
        }, START_ANIMATION_WAIT);
        setTimeout(() => {
          ctx.hideFloorCanvas(startFloorIndex);
          ctx.drawAccessRoutes(
            ctx,
            accessRoute,
            end,
            1,
            accessRoute[1],
            accessRoute[2]
          ); 
        }, DEFAULT_ANIMATION_TIMEOUT_EXTEND);
      } else {
        ctx.findRouteOnDestinationFloor(endFloorIndex, start, end, ctx);
      }
    }, START_ANIMATION_WAIT);
  }

  // 3º: Dibujamos caminos a los accesos, escaleras, etc.
  drawAccessRoutes(ctx, accessRoute, end, index, currentAccess, nextAccess) {
    let { marginTop, canvasses, screenWidth } = ctx.state;
    let { config } = this.props;
    removeStartIcon();
    removeStairsIcon();
    if (!nextAccess) {
      // Se llegó al piso final
      if(index == 1) { // Acaba de ingresar al método. La ruta tenía un acceso y hay que mostrar el 
        ctx.showFloorCanvas(parseInt(currentAccess.access_info.floor, 10));
      }
      accessRoute.push(end);
      setTimeout(() => {
        ctx.findRouteOnDestinationFloor(
          parseInt(end.store_info.nivel, 10),
          currentAccess,
          end,
          ctx,
          true
        );
      }, DEFAULT_ANIMATION_TIMEOUT);
    } else {
      // Aún quedan rutas a accesos por mostrar
      ctx.showFloorCanvas(parseInt(nextAccess.access_info.floor, 10));
      if (currentAccess.access_info.floor === nextAccess.access_info.floor) {
        // Mostrar animación de piso con escaleras
        setTimeout(() => {
          drawStairsIcon(
            currentAccess.x, currentAccess.y, config.w, config.h, 200, !!currentAccess.access_description ? this.isUpOrDown(currentAccess.access_description) : undefined, parseInt(currentAccess.access_info.floor, 10), screenWidth);
          drawStairsIcon(nextAccess.x, nextAccess.y, config.w, config.h, 200, !!nextAccess.access_description ? this.isUpOrDown(nextAccess.access_description) : undefined, parseInt(nextAccess.access_info.floor, 10), screenWidth);
          let resultInnerAccess = ctx
            .generatePathFinder(parseInt(currentAccess.access_info.floor, 10))
            .find(nextAccess.id, currentAccess.id);
          setTimeout(() => {
            removeStartIcon();

            drawStairsIcon(currentAccess.x, currentAccess.y, config.w, config.h, 200, undefined, parseInt(currentAccess.access_info.floor, 10), screenWidth);
            drawStairsIcon(nextAccess.x, nextAccess.y, config.w, config.h, 200, undefined, parseInt(nextAccess.access_info.floor, 10), screenWidth);

            drawRoute(
              resultInnerAccess.map(r => r.data),
              canvasses[parseInt(currentAccess.access_info.floor, 10)],
              marginTop,
              null,
              config,
              parseInt(currentAccess.access_info.floor, 10),
              screenWidth
            );
            setTimeout(() => {
              index++;
              this.drawAccessRoutes(
                ctx,
                accessRoute,
                end,
                index,
                accessRoute[index],
                accessRoute[index + 1]
              );
            }, DEFAULT_ANIMATION_TIMEOUT);
          }, START_ANIMATION_WAIT);
        }, 1000);
      } else {
        // Hay que cambiar de piso
        index++;
        ctx.hideFloorCanvas(parseInt(currentAccess.access_info.floor, 10));
        setTimeout(
          this.drawAccessRoutes(
            ctx,
            accessRoute,
            end,
            index,
            accessRoute[index],
            accessRoute[index + 1]
          ),
          DEFAULT_ANIMATION_TIMEOUT
        );
      }
    }
  }

  // 4º: Cuando la vista ya está en el piso de destino
  findRouteOnDestinationFloor(
    endFloorIndex,
    start,
    end,
    ctx,
    startFromAccess = false
  ) {
    let { config } = this.props;
    let { marginTop, canvasses, screenWidth } = ctx.state;
    ctx.setState({
      currentFloor: endFloorIndex,
      currentCanvas: canvasses[endFloorIndex]
    });
    if (startFromAccess) {
      let setNewStart = false;
      // Start es el acceso pero en el piso de inicio. Hay que buscar el que se conecta en este piso
      ctx.getFloorAccesses(endFloorIndex).forEach(n => {
        n.access_info.pairs.forEach(id => {
          if (id === start.id && !setNewStart) {
            setNewStart = true;
            start = n;
          }
        });
      });
      drawStairsIcon(start.x, start.y, config.w, config.h, 200, !!start.access_description ? start.access_description : undefined, endFloorIndex, screenWidth);
      setTimeout(() => {
        removeStairsIcon();
        drawStairsIcon(start.x, start.y, config.w, config.h, 200, undefined, endFloorIndex, screenWidth);
      }, START_ANIMATION_WAIT);
    }
    // console.log("los lugares", end, start, endFloorIndex);
    // Posible error if level defined in the store is not the same as the one defined in the node tree
    // Verify that the level of the node is correctly setted in the WP before making the nodes tree backend

    // console.log("el ante error", end, start, endFloorIndex, ctx)
    setTimeout(() => {
      let result = ctx.generatePathFinder(endFloorIndex).find(end.id, start.id);
      this.drawEndIcon(end, false);
      drawRoute(
        result.map(r => r.data),
        canvasses[endFloorIndex],
        marginTop,
        () => ctx.setOnAnimation(false),
        config,
        endFloorIndex,
        screenWidth
      );
      let ciclos = 0;
      const interval = setInterval(() => {
        ciclos++;
        if (ctx.state.onAnimation === false || ciclos >= 25) {
          clearInterval(interval);
          removeEndIcon();
          removeServiceIcon();
          this.drawEndIcon(end, true);
        }
      }, 200);
    }, startFromAccess ? START_ANIMATION_WAIT : 0);
  }

  /*
   * Tries to find and access using the same stair column
   */
  getAccessOnSameStairColumn(startAccess, destinationFloor, accum, ctx) {
    // Base case: if startAccess is undefined, return null
    if (!startAccess) return null;
    
    // Check if we've already visited this node to prevent infinite recursion
    let alreadyAdded = accum.some(n => n.id === startAccess.id);
    if (alreadyAdded) return null;
    
    // Create a new accumulator array with the current node
    let newAccum = [...accum, startAccess];
    
    // Check if we've reached the destination floor
    if (startAccess.access_info.pairs[`${destinationFloor}`]) {
      // We found a path to the destination floor
      return newAccum;
    }
    
    // No direct path, try to find a path through connected floors
    // Convert pairs object to array for easier iteration
    const pairs = Object.entries(startAccess.access_info.pairs);
    
    for (let [floor, id] of pairs) {
      // Get the access node on the connected floor
      const floorNum = parseInt(floor, 10);
      const onDestAccess = this.getNodeById(id, floorNum);
      
      if (!onDestAccess) continue; // Skip if node doesn't exist
      
      // Recursively try this access node
      const result = this.getAccessOnSameStairColumn(
        onDestAccess,
        destinationFloor,
        newAccum,
        ctx
      );
      
      // If we found a path, return it
      if (result) return result;
    }
    
    // No path found through this access node
    return null;
  }

  /*
   * Tries to find and access using all available stairs
   */
  getAccessExhaustively(
    startAccess,
    destinationFloor,
    accum,
    ctx,
    onFinish,
    sign
  ) {
    // Base case: if startAccess is undefined, return
    if (!startAccess) return null;
    
    // Check if we've already visited this access node to prevent infinite recursion
    let alreadyAdded = accum.some(n => n.id === startAccess.id);
    if (alreadyAdded) return null;
    
    // Add current access node to the path
    let newAccum = [...accum, startAccess];
    
    // Check if we've reached the destination floor directly
    if (startAccess.access_info.pairs[`${destinationFloor}`]) {
      // We found a path to the destination floor
      onFinish(newAccum);
      return newAccum;
    }
    
    // No direct path, try to find a path through other access nodes
    // Convert pairs object to array for easier iteration
    const pairs = Object.entries(startAccess.access_info.pairs);
    
    for (let [floor, id] of pairs) {
      // Get the access node on the connected floor
      const floorNum = parseInt(floor, 10);
      const onDestAccess = this.getNodeById(id, floorNum);
      
      if (!onDestAccess) continue; // Skip if node doesn't exist
      
      // Get all access nodes on this floor
      const accessesOnFloor = this.getClosestAccessesFromAccess(onDestAccess, floorNum);
      
      // Try each access node on this floor
      for (let n of accessesOnFloor) {
        // Make sure we're moving in the right direction (up or down)
        const nFloor = parseInt(n.access_info.floor, 10);
        const sFloor = parseInt(startAccess.access_info.floor, 10);
        
        if ((sign === "up" && nFloor > sFloor) || (sign === "down" && nFloor < sFloor)) {
          // Recursively try this access node
          const result = this.getAccessExhaustively(
            n,
            destinationFloor,
            newAccum,
            ctx,
            onFinish,
            sign
          );
          
          // If we found a path, return it
          if (result) return result;
        }
      }
    }
    
    // No path found through this access node
    return null;
  }

  getNodeById(id, floor) {
    return this.getFloorNodes(floor).filter(n => n.id === id)[0];
  }

  getClosest(target, list) {
    let distances = list.map(a => {
      a.auxDistance = distance(target, a);
      return a;
    });
    return distances.sort((a, b) => a.auxDistance > b.auxDistance);
  }

  getFloorAccesses(floor) {
    return this.getFloorNodes(floor).filter(n => n.access);
  }

  getClosestAccess(startNode, floor) {
    let stairs = this.getFloorAccesses(floor);
    return this.getClosest(startNode, stairs);
  }

  getClosestAccessesFromAccess(startNode, floor) {
    let stairs = this.getFloorAccesses(floor).filter(
      n => n.id !== startNode.id
    );
    return this.getClosest(startNode, stairs);
  }

  hideFloorCanvas(floor) {
    console.log("Hiding floor canvas:", floor);
    floor = parseInt(floor, 10);
    let id = CANVAS_ID_BY_FLOOR[floor];
    if (!id) return;
    // Antes usaba .animateCss("fadeOutDown", callback), que agrega las clases
    // "animated fadeOutDown" y espera un evento "animationend" para recién
    // ahí ocultar el canvas. Si el piso anterior nunca terminó su propia
    // animación (p.ej. porque se encadenan varias transiciones de piso
    // rápido), la clase "animated" ya está puesta y el navegador no dispara
    // un nuevo "animationend" para ella: el callback nunca corre y el canvas
    // de ese piso queda visible para siempre, superpuesto con el piso nuevo
    // (fondo, ruta e íconos duplicados). Ocultar directamente evita ese
    // problema por completo.
    $(`#${id}`).css("display", "none");
    $(`#${id}-labels`).css("display", "none");
  }

  showFloorCanvas(floor) {
    console.log("Showing floor canvas:", floor);
    floor = parseInt(floor, 10);
    let id = CANVAS_ID_BY_FLOOR[floor];
    if (!id) return;
    $(`#${id}`).css("display", "block");
    $(`#${id}-labels`).css("display", "block");
  }

  generatePathFinder(floor) {
    let { graphs } = this.state;
    let ret = path.aStar(graphs[floor], {
      distance(fromNode, toNode) {
        // Castigamos a los links que llegan a una tienda
        let dx = fromNode.data.x - toNode.data.x;
        let dy = fromNode.data.y - toNode.data.y;
        if (toNode.data.store) return 10 * Math.sqrt(dx * dx + dy * dy);
        else return Math.sqrt(dx * dx + dy * dy);
      }
    });
    return ret;
  }

  getFloorNodes(floor) {
    floor = parseInt(floor, 10);
    switch (floor) {
      case PISO_m1_INDEX:
        return pm1;
      case PISO_0_INDEX:
        return p0;
      case PISO_1_INDEX:
        return p1;
      case PISO_2_INDEX:
        return p2;
      case PISO_3_INDEX:
        return p3;
      case PISO_4_INDEX:
        return p4;
      default:
        return [];
    }
  }

  setOnAnimation(onAnimation, callback) {
    this.setState(
      {
        onAnimation
      },
      callback
    );
  }

  setUserMessage(message) {
    this.setState({ userMessage: message });
  }

  setCurrentCanvas(floor, callback) {
    this.setState(
      {
        currentCanvas: this.state.canvasses[floor]
      },
      callback
    );
  }

  setupGraphs() {
    let ctx = this;
    let graphs = {};
    let markedSteps = {};
    if (pm1) {
      graphs[-1] = this.populateGraph(pm1);
      markedSteps[-1] = pm1;
    }
    if (p0) {
      graphs[0] = this.populateGraph(p0);
      markedSteps[0] = p0;
    }
    if (p1) {
      graphs[1] = this.populateGraph(p1);
      markedSteps[1] = p1;
    }
    if (p2) {
      graphs[2] = this.populateGraph(p2);
      markedSteps[2] = p2;
    }
    if (p3) {
      graphs[3] = this.populateGraph(p3);
      markedSteps[3] = p3;
    }
    if (p4) {
      graphs[4] = this.populateGraph(p4);
      markedSteps[4] = p4;
    }

    this.setState(
      {
        markedSteps,
        graphs,
        onAnimation: true
      },
      () => {
        setTimeout(function() {
          ctx.findRoute();
        }, START_ANIMATION_WAIT);
      }
    );
  }

  populateGraph(p) {
    let { marginTop } = this.state;
    let g = createGraph();
    p.forEach(d => {
      //paintDot(this.state.context, d)
      if (!d.traslated) {
        d.yRotated += marginTop;
        d.traslated = true;
      }
      d.links.forEach(l => {
        let fromDot = p.filter(d => d.id === l.from)[0];
        let end = p.filter(d => d.id === l.to)[0];
        //console.log(l)
        g.addLink(fromDot.id, end.id, { weight: distance(fromDot, end) });
      });
      g.addNode(d.id, d);
    });
    return g;
  }

  onRepeat() {
    let { onAnimation } = this.state;
    removeEndIcon();
    if (onAnimation) return;
    this.setOnAnimation(true, () => this.findRoute());
  }

  onBack() {
    let { onAnimation } = this.state;
    if (onAnimation) return;
    removeEndIcon();
    removeServiceIcon();
    removeStartIcon();
    removeStairsIcon();
    let { canvasses } = this.state;
    clearRoutes(canvasses);
    this.setState({
      mode: MODE_MAP
    });
    this.props.onBack();
  }

  getEndStoreDisccount() {
    let { disccounts, end } = this.props;
    if (disccounts && end.store_info)
      return disccounts.filter(d => d.tienda_id === end.store_info.id);
    else return false;
  }

  drawEndIcon(end, addTitle) {
    let { marginTop, screenWidth } = this.state;
    let { config } = this.props;

    const title = addTitle === true && !!end.store_info ? formatDisplayName(end.store_info.title) : undefined;
    const endFloor = end.store_info ? parseInt(end.store_info.nivel, 10) : undefined;
    if (end.service)
      switch (this.props.end.type) {
        case "bathroom":
          drawServiceIcon(end.x, end.y, config.w, config.h, banoPin, 200, title, endFloor, screenWidth);
          break;
        case "redbanc":
          drawServiceIcon(end.x, end.y, config.w, config.h, cajeroPin, 200, title, endFloor, screenWidth);
          break;
        case "casino":
          drawServiceIcon(end.x, end.y, config.w, config.h, casinoPin, 200, title, endFloor, screenWidth);
          break;
        case "cafeteria":
          drawServiceIcon(end.x, end.y, config.w, config.h, cafeteriaPin, 200, title, endFloor, screenWidth);
          break;
        case "dd":
          drawServiceIcon(end.x, end.y, config.w, config.h, directorioPin, 200, title, endFloor, screenWidth);
          break;
        case "info":
          drawServiceIcon(
            end.x,
            end.y,
            config.w,
            config.h,
            informacionPin,
            200,
            title,
            endFloor,
            screenWidth
          );
          break;
        case "milk":
          drawServiceIcon(end.x, end.y, config.w, config.h, lactanciaPin, 200, title, endFloor, screenWidth);
          break;
        case "elevator":
          drawServiceIcon(end.x, end.y, config.w, config.h, ascensorPin, 200, title, endFloor, screenWidth);
          break;
        case "parking":
          drawServiceIcon(
            end.x,
            end.y,
            config.w,
            config.h,
            estacionamientoPin,
            200,
            title,
            endFloor,
            screenWidth
          );
          break;
        default:
          drawEndIcon(end.x, end.y, config.w, config.h, 200, title, endFloor, screenWidth);
          break;
      }
    else drawEndIcon(end.x, end.y, config.w, config.h, 150, title, endFloor, screenWidth);
  }

  decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return formatDisplayName(textArea.value);
  }

  renderEndLocationName(end) {
    if (end && end.store_info) return this.decodeHTMLEntities(end.store_info.title);
    else if (end && end.service) return this.decodeHTMLEntities(end.name);
    else return "No definido";
  }

  render() {
    let { start, end, stores, pm1, p0, p1, p2, p3, p4 } = this.props;
    let { mode, marginTop, currentFloor } = this.state;
    let modeMap = mode === MODE_MAP;
    let modeDiscs = mode === MODE_DISCCOUNTS;
    let disccounts = this.getEndStoreDisccount();
    return (
      <div>
        <div id="mapview">
          <div className="stores-info pt-3">
            <div className="pb-3 pl-4 pr-4 mt-1 header-form-map">
              <div
                className="d-none d-md-flex"
                style={{
                  position: "absolute",
                  top: "10px",
                  left: 0,
                  right: 0,
                  justifyContent: "space-between",
                  padding: "0 40px"
                }}
              >
                <div
                  onClick={() => this.onBack()}
                  className="repeat-btn desktop-map-btn"
                >
                  <i className="fa fa-arrow-left" />
                  &nbsp; Volver
                </div>
                <div
                  onClick={() => this.onRepeat()}
                  className="repeat-btn desktop-map-btn"
                >
                  <i className="fa fa-repeat" />
                  &nbsp; Repetir
                </div>
              </div>
              <div
                id="left-container"
                className="float-left route-container"
                style={{ height: "0px" }}
              >
                <img
                  alt=""
                  style={{ position: "relative", top: "10px", left: "-9px" }}
                  src={endIcon}
                />
                <img
                  alt=""
                  style={{ position: "relative", top: "37px", left: "-19px" }}
                  src={whiteLine}
                />
                <img
                  alt=""
                  style={{ position: "relative", top: "70px", left: "-27px" }}
                  src={startIcon}
                />
              </div>
              <div
                className="card card-1 pl-1 pr-1 pt-2 pb-2"
                onClick={() => this.onBack()}
              >
                {start ? formatDisplayName(start.store_info.title) : "No definido"}
              </div>
              <div
                className="card card-1 pl-1 pr-1 mt-3 pt-2 pb-2"
                onClick={() => this.onBack()}
              >
                {this.renderEndLocationName(end)}
              </div>
            </div>
            <div className="mb-1 text-center">
              <button
                onClick={() => this.setState({ mode: MODE_MAP })}
                className={`btn-rounded ${
                  modeMap ? "btn-rounded-selected" : ""
                } mr-3`}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  src={modeMap ? routeIcon : routeIconWhite}
                  alt=""
                  style={{ verticalAlign: "unset", paddingTop: "4px" }}
                  height={"17px"}
                  width={"auto"}
                />
                &nbsp;&nbsp; RUTA &nbsp;&nbsp;&nbsp;&nbsp;
              </button>
              {disccounts && disccounts.length > 0 && (
                <button
                  onClick={() => this.setState({ mode: MODE_DISCCOUNTS })}
                  className={`btn-rounded ${
                    modeDiscs ? "btn-rounded-selected" : ""
                  }`}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <img
                    src={modeDiscs ? tagIcon : tagIconWhite}
                    alt=""
                    style={{ verticalAlign: "unset", paddingTop: "4px" }}
                    height={"17px"}
                    width={"auto"}
                  />
                  &nbsp;&nbsp; DESCUENTOS &nbsp;&nbsp;&nbsp;&nbsp;
                </button>
              )}
            </div>
            <div style={{ display: modeMap ? "block" : "none" }}>
              <FloorsStrip
                pm1={pm1}
                p0={p0}
                p1={p1}
                p2={p2}
                p3={p3}
                p4={p4}
                selected={currentFloor}
                start={start}
              />
            </div>
          </div>
          <div
            id="mapcontainer"
            style={{ display: modeMap ? "block" : "none" }}
          >
            <div id="iconsContainer" />
            <div id="mapcontent" />
            <div className="clearfix" />
            <div className="actions-tab d-md-none">
              <div
                onClick={() => this.onBack()}
                className="pull-left repeat-btn"
              >
                <div className="fa fa-arrow-left" />
                {"  "} Volver
              </div>
              <div
                onClick={() => this.onRepeat()}
                className="pull-right repeat-btn"
              >
                <div className="fa fa-repeat" />
                {"  "} Repetir
              </div>
            </div>
            <StoreWidget storeInfo={end.store_info} stores={stores} />
          </div>
        </div>
        <div
          style={{
            display: modeDiscs ? "block" : "none",
            marginTop: marginTop
          }}
          id="disccountscontainer"
          className="disccounts-view-container"
        >
          {disccounts && disccounts.length > 0 && (
            <div className="text-center pt-3">
              <DisccountWidget disccounts={disccounts} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/views/MapView.js